import AuthInterceptor from '../AuthInterceptor';

// sms 인증 문자 발송 
// request data
//  - phoneNumber : 휴대전화번호
//  - displayName : 실명
export function authSMS(request) {
	return AuthInterceptor({
		url: '/auth/sms',
		method: 'post',
		data: request,
	});
}


// sms 인증 확인
// request data
//	- phoneNumber : 전화번호
//	- authNumber : 인증번호
export function checkAuthSMS({phoneNumber, authNumber}) {
	return AuthInterceptor({
		url: `/auth/sms/phone/${phoneNumber}/num/${authNumber}`,
		method: 'get'
	})
}


// 로그인 (with 휴대전화 인증)
// request data
//  - phoneNumber : 휴대전화번호
//  - authNumber : 인증번호
//  - displayName : 실명
//  - pushToken : 추후 추가 예정 (일단은 빈 string 보내기)
export function authPhoneSignin(queryStringRequest) {
	return AuthInterceptor({
		url: '/auth/phone/signin',
		method: 'post',
		data: queryStringRequest,
	});
}


// 로그인 (with 패스워드)
//  request data
// 	- username : 사용자 계정 *required
// 	- password : 패스워드 *required
// 	- displayName : 이름
// 	- phoneNumber : 전화번호
//	- staff : 스탭 여부
//  - pushToken : 추후 추가 예정 (일단은 빈 string 보내기)
export function signinWithPW(request) {
	return AuthInterceptor({
		url: '/auth/pwd/signin',
		method: 'post',
		data: request
	})
}


// 계정 패스워드 변경 (기존 패스워드를 모를 경우)
// request data
// 	- username : 사용자 계정 *required
// 	- displayName : 이름 *required
// 	- phoneNumber : 전화번호 *required
//  - authNumber : 인증번호 *required
//	- newPassword : 새 비밀번호 
export function changePW(request) {
	return AuthInterceptor({
		url: '/auth/pwd/reset-password',
		method: 'post',
		data: request
	})
}


// 계정 패스워드 변경 (기존 패스워드를 알 경우)
// request data
//	- username : 사용자 계정
//	- originPassword : 기존 비밀번호
//	- newPassword : 새 비밀번호
export function changePWWithOrigin(request) {
	return AuthInterceptor({
		url: '/auth/pwd/change-password',
		method: 'post',
		data: request
	})
}

// 휴대폰번호 변경
// request data
//	- username : 아이디
//	- oldPhoneNumber : 기존 휴대폰 번호
//	- newPhoneNumber :  신규 휴대폰 번호
//	- authNumber : 인증번호 (6자리)
export function postAuthPwdChangePhoneNumber(request) {
	return AuthInterceptor({
		url: '/auth/pwd/change-phonenumber',
		method: 'post',
		data: request
	})
}


// 사용자 ID 찾기
// request data
//	- displayName : 이름
//	- phoneNumber : 전화번호
//	- authNumber : 인증번호
export function getUserID(request) {
	return AuthInterceptor({
		url: '/auth/pwd/username',
		method: 'post',
		data: request
	})
}


// 계정 존재 여부 확인
// request data
//	- username : 아이디
//	- displayName : 이름
//	- phoneNumber : 전화번호
//	- authNumber : 인증번호
export function checkExistUser(request) {
	return AuthInterceptor({
		url: '/auth/pwd/user-state',
		method: 'post',
		data: request
	})
}